/* eslint-disable no-undef */
export const chatLoader = (token) => {
    function initializeChatWidget(e) {
      console.log("Chat LOADED:", e);
    }
    const lang = localStorage.getItem("lang") || "en";
    const newDiv = document.createElement("div");
    if (!document.getElementById("root")) {
      const newDiv = document.createElement("div");
      newDiv.id = "root";
      document.body.appendChild(newDiv);
    }
    document.body.appendChild(newDiv);
    WizzUtils.componentLoader({
      url: "https://sync.wizztech.us",
      func: initializeChatWidget,
      params: {
        language: lang,
        token
      },
    });
  };
  